import type { RiskAnalystListSession } from './riskAnalystSession'
import type { DbTableResult } from './dbTableAnswers'
import type { ProfileMitigation } from './tryAnswerRiskRatingsFromDb'
import type { RiskRatingSupplier } from './supplierRiskRatingsTable'

export type PersistedChatMessage = {
  role: 'user' | 'assistant' | 'system'
  content: string
  scorecard?: RiskRatingSupplier
  scorecardBrands?: string[]
  scorecardMitigations?: ProfileMitigation[]
  dbTable?: DbTableResult
  /** Legal names the user can click instead of retyping. */
  choices?: string[]
}

const KEY = 'es_ra_chat_v1'

type Persisted = {
  messages: PersistedChatMessage[]
  listSession: RiskAnalystListSession | null
  awaitingSupplierFor: 'questions_to_ask' | 'next_best_actions' | null
  /** Absent in chats saved before thread memory. Treat that as empty. */
  lastSupplier?: string | null
  lastCategory?: string | null
}

/** Keep Risk Analyst history visible across tab switches / remounts within the session. */
export function loadRiskAnalystChat(): Persisted | null {
  try {
    const raw = sessionStorage.getItem(KEY)
    if (!raw) return null
    const data = JSON.parse(raw) as Persisted
    if (!Array.isArray(data.messages) || data.messages.length === 0) return null
    return data
  } catch {
    return null
  }
}

export function saveRiskAnalystChat(data: Persisted): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(data))
  } catch {
    // ignore
  }
}
